
import Component from '../../../assets/scripts/modules/component'
import SwiperWrapper from '../../../assets/scripts/modules/swiper-wrapper'

const SWIPER_OPTIONS = {
  loop: false,
  slidesPerView: 2,
  spaceBetween: 10,
  grabCursor: true,
  roundLengths: false,
  watchOverflow: false,
  breakpoints: {
    530: { slidesPerView: 3 },
    800: { slidesPerView: 4 },
    1180: { slidesPerView: 8 },
    1580: { slidesPerView: 8 },
    2240: { slidesPerView: 8 }
  }
}

export default class RaggedCardGridComponent extends Component {
  init () {
    this.container = this.element.querySelector('.ragged-card-grid__cards')
    this.cards = [...this.element.querySelectorAll('.card')]
    this.filteredCards = this.cards
    this.callToAction = this.element.querySelector('.ragged-card-grid__call-to-action')

    if (!this.container) {
      return
    }

    window.addEventListener('resize', () => this.onWindowResize())
    this.onWindowResize()

    this.filterButtons = [...this.element.querySelectorAll('.ragged-card-grid__filter-bar .button')]
    this.filterButtons.forEach(button => button.addEventListener('click', () => this.onFilterButtonClick(button)))

    this.showInitial = parseInt(this.element.getAttribute('data-show-initial'), 10) || 20
    this.showIncrement = parseInt(this.element.getAttribute('data-show-increment'), 10) || 20
    this.showCurrent = this.showInitial
    this.element.setAttribute('data-show-current', this.showCurrent)

    this.showMoreButton = this.element.querySelector('.button--show-more')

    if (this.showMoreButton) {
      this.showMoreButton.addEventListener('click', () => this.onShowMoreButtonClick())
      this.showLimitedAmount()
    }

    this.sortDropdown = this.element.querySelector('.dropdown-field__input[name="sort"]')

    if (this.sortDropdown) {
      this.sortDropdown.addEventListener('change', () => {
        this.onSortDropdownChange()
      })
    }

    this.initSwiper()
  }

  initSwiper () {
    this.carousel = this.element.querySelector('.ragged-card-carousel__swiper-container')

    if (!this.carousel) {
      return
    }

    this.loadSwiper()
  }

  loadSwiper () {
    const options = { ...SWIPER_OPTIONS }
    this.swiperWrapper = new SwiperWrapper(this.carousel, options)
  }

  onWindowResize () {
    this.cards.forEach(card => this.resizeCard(card))

    if (this.callToAction) {
      this.callToAction.style.gridRowEnd = ''

      const rowHeight = parseInt(window.getComputedStyle(this.container).getPropertyValue('grid-auto-rows'))
      const rowGap = parseInt(window.getComputedStyle(this.container).getPropertyValue('grid-row-gap'))
      const rowSpan = Math.ceil((this.callToAction.querySelector('.ragged-card-grid__call-to-action-container').getBoundingClientRect().height + rowGap) / (rowHeight + rowGap))

      this.callToAction.style.gridRowEnd = `span ${rowSpan}`
      this.callToAction.classList.add('ragged-card-grid__call-to-action--resized-staggered')
    }
  }

  resizeCard (card) {
    if (!card) {
      return
    }

    card.style.gridRowEnd = ''

    const rowHeight = parseInt(window.getComputedStyle(this.container).getPropertyValue('grid-auto-rows'))
    const rowGap = parseInt(window.getComputedStyle(this.container).getPropertyValue('grid-row-gap'))
    const rowSpan = Math.ceil((card.querySelector('.card__image').getBoundingClientRect().height + rowGap) / (rowHeight + rowGap))

    card.style.gridRowEnd = `span ${rowSpan}`
    card.classList.add('card--resized-staggered')
  }

  onFilterButtonClick (button) {
    if (!button) {
      return
    }

    const buttonSlug = button.getAttribute('data-slug') || ''

    if (!buttonSlug) {
      this.cards.forEach(card => card.classList.remove('card--invisible'))
    } else {
      this.cards.forEach(card => {
        card.classList.add('card--invisible')

        const cardSlugs = (card.getAttribute('data-theme-slug') || '').split(',')

        cardSlugs.forEach(cardSlug => {
          if (cardSlug.trim() === buttonSlug.trim()) {
            card.classList.remove('card--invisible')
          }
        })
      })
    }

    this.filterButtons.forEach(button => button.classList.remove('button--selected'))
    button.classList.add('button--selected')

    this.showCurrent = this.showInitial
    this.showLimitedAmount()
  }

  onShowMoreButtonClick () {
    this.showCurrent += this.showIncrement

    this.showLimitedAmount()
  }

  showLimitedAmount () {
    this.cards = [...this.element.querySelectorAll('.card')]
    const filterlist = this.cards.filter(card => !card.classList.contains('card--invisible'))

    filterlist.forEach(card => card.classList.add('card--out-of-range'))

    const sublist = filterlist.slice(0, this.showCurrent)
    sublist.forEach(card => card.classList.remove('card--out-of-range'))

    this.showMoreButton.classList.toggle('button--hidden', sublist.length === filterlist.length)

    this.onWindowResize()
  }

  onSortDropdownChange () {
    const selected = this.sortDropdown.selectedOptions[0]
    const value = (selected ? selected.value : '').split('-')

    if (!selected || !value) {
      return
    }

    const property = value[0] || ''
    const direction = (value.length > 1) ? (value[1] || 'desc') : 'desc'

    if (!property) {
      return
    }

    let results = [...this.cards]

    results = results.sort((a, b) => (parseInt(a.getAttribute(`data-${property}`) || 0, 10) > parseInt(b.getAttribute(`data-${property}`) || 0, 10)) ? -1 : 1)

    if (direction === 'asc') {
      results = results.reverse()
    }

    results.forEach(card => {
      card.classList.remove('card--out-of-range')
      this.container.appendChild(card)
    })

    const filterlist = results.filter(card => !card.classList.contains('card--invisible'))
    filterlist.forEach(card => card.classList.add('card--out-of-range'))

    const sublist = filterlist.slice(0, this.showCurrent)
    sublist.forEach(card => card.classList.remove('card--out-of-range'))

    this.container.appendChild(this.callToAction)

    this.onWindowResize()
  }
}

window.addEventListener('init-load', () => document.querySelectorAll('.ragged-card-grid').forEach(element => {
  element.instance = element.instance || new RaggedCardGridComponent(element)
}))
